export const LOGIN = 'user.LOGIN'
export const SET_LOGGED_IN = 'user.SET_LOGGED_IN'

export const SAVE_PROFILE = 'user.SAVE_PROFILE'
export const GET_PROFILE = 'user.GET_PROFILE'
export const SET_PROFILE = 'user.SET_PROFILE'

export const PASSWORD_RECOVERY = 'user.PASSWORD_RECOVERY'
export const RESET_PASSWORD = 'user.RESET_PASSWORD'
export const CHANGE_PASSWORD = 'user.CHANGE_PASSWORD'

export const GET_REPORT_DATA_BY_TOKEN = 'user.GET_REPORT_DATA_BY_TOKEN'
export const SET_REPORT_DATA_BY_TOKEN = 'user.SET_REPORT_DATA_BY_TOKEN'

export const login = (data, callback) => ({
  type: LOGIN,
  data,
  callback,
})

export const setLoggedIn = (loggedIn, username) => ({
  type: SET_LOGGED_IN,
  loggedIn,
  username,
})

export const saveProfile = (data, callback) => ({
  type: SAVE_PROFILE,
  data,
  callback,
})

export const getProfile = () => ({
  type: GET_PROFILE,
})

export const setProfile = (data) => ({
  type: SET_PROFILE,
  data,
})

export const passwordRecovery = (email, captcha, isResend, callback) => ({
  type: PASSWORD_RECOVERY,
  email,
  captcha,
  isResend,
  callback,
})

export const resetPassword = (data, callback) => ({
  type: RESET_PASSWORD,
  data,
  callback,
})

export const changePassword = (data, callback) => ({
  type: CHANGE_PASSWORD,
  data,
  callback,
})

export const getReportDataByToken = (token, id, collectionId) => ({
  type: GET_REPORT_DATA_BY_TOKEN,
  token,
  id,
  collectionId
})

export const setReportDataByToken = (reportData) => ({
  type: SET_REPORT_DATA_BY_TOKEN,
  reportData
})
